import React from 'react';
import './App.css';
import 'rsuite/dist/rsuite-no-reset.min.css';

import { AppProviders } from './providers/AppProvides';

function App() {
  return (
    <React.StrictMode>
      <AppProviders />
    </React.StrictMode>
  );
}

export default App;
